/* styles.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./styles.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  reportingLinesEmptyStateContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1b1v _1bsb1osq _ca0qoahv _u5f3v47k _n3tdoahv _19bvv47k",
  reportingLinesEmptyStateContent: "_19pkutpp _otyrutpp",
  reportingLinesEmptyStateImage: "_19pkutpp _otyrutpp",
  reportingLinesEmptyStateHeading: "_11c8lodh",
  infoMessage: "_otyrv47k"
};
export var ReportingLinesEmptyStateContainer = function ReportingLinesEmptyStateContainer(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.reportingLinesEmptyStateContainer,
    testId: testId
  }, children);
};
export var ContentSection = function ContentSection(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.reportingLinesEmptyStateContent
  }, children);
};
export var InfoMessage = function InfoMessage(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.infoMessage
  }, children);
};